"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_select_1 = __importStar(require("react-select"));
const styles_1 = require("./styles");
const MenuIcon_1 = __importDefault(require("../MenuIcon/MenuIcon"));
class OrganizationDropdown extends React.Component {
    constructor() {
        super(...arguments);
        this.ValueContainer = (props) => {
            return (react_select_1.components.ValueContainer && (React.createElement(react_select_1.components.ValueContainer, Object.assign({}, props),
                React.createElement(MenuIcon_1.default, { type: "COMPANY_SELECT", icon: "blue" }),
                props.children)));
        };
        this.DropdownIndicator = (innerProps) => {
            if (this.props.collapsed || this.props.transitioning) {
                return null;
            }
            const { selectProps } = innerProps;
            let className = 'aio-dropdown-icon';
            if (selectProps && selectProps.menuIsOpen) {
                className += ' aio-dropdown-icon-up';
            }
            else {
                className += ' aio-dropdown-icon-down';
            }
            return react_select_1.components.DropdownIndicator && React.createElement("div", { className: className });
        };
        this.handleChange = (selectedItem) => {
            if (selectedItem && !(selectedItem instanceof Array)) {
                const organization = this.props.organizations.find((org) => org.organizationId === selectedItem.value);
                if (organization) {
                    this.props.setCurrentOrganization(organization);
                }
            }
        };
    }
    render() {
        const { mode, collapsed, transitioning } = this.props;
        if (this.props.organizations.length === 1) {
            let name = this.props.current.organizationName;
            if (transitioning || collapsed) {
                name = this.props.current.organizationName.slice(0, 1);
            }
            return React.createElement("div", { className: "single-item" }, name);
        }
        const options = this.props.organizations
            .map((o) => ({ value: o.organizationId, label: o.organizationName }))
            .sort((a, b) => a.label.localeCompare(b.label));
        return (React.createElement(react_select_1.default, { id: "org-selector", name: "org-selector", components: {
                DropdownIndicator: this.DropdownIndicator,
                ValueContainer: this.ValueContainer,
            }, value: {
                label: this.props.current.organizationName,
                value: this.props.current.organizationId,
            }, styles: styles_1.customStyles(mode, collapsed && !transitioning), options: options, onChange: this.handleChange, tabSelectsValue: false, openMenuOnFocus: true, isSearchable: !collapsed, placeholder: '' }));
    }
}
exports.default = OrganizationDropdown;
//# sourceMappingURL=OrganizationDropdown.js.map